<div>
  <form [formGroup]="form" *ngIf="showSearch">
    <div class="mb-3">
      <input
        [placeholder]="'AbpUi::Search' | abpLocalization"
        formControlName="term"
        class="form-control"
      />
    </div>
  </form>
  <app-locations-tree
    [isLoading]="isLoading"
    [data]="data"
    [readonly]="readonly"
    [selectedNode]="selectedLocation"
    (selectedNodeChange)="onSelectedNodeChange($event)"
    (checkedKeysChange)="onCheckedKeysChange($event)"
    [locationDefinition]="locationDefinition"
    [displayHeaders]="displayHeaders"
    [withLookup]="withLookup"
    [hasAssociatedInspections]="hasAssociatedInspections"
    [hasAssociatedAssets]="hasAssociatedAssets"
    [checkable]="checkable"
    [checkStrictly]="checkStrictly"
    [pinOrKeyringPassword]="pinOrKeyringPassword"
    [isGuest]="isGuest"
    [showTransferNotes]="showTransferNotes"
    [showSubAssetsNotes]="showSubAssetsNotes"
    [(transferNotes)]="transferNotes"
    [(subAssetsNotes)]="subAssetsNotes"
    (transferNotesChange)="transferNotesChange.emit($event)"
    (subAssetsNotesChange)="subAssetsNotesChange.emit($event)"
  >
  </app-locations-tree>
</div>
